module.exports = __webpack_public_path__ + "static/media/mushroomCapsBack.9d1da824.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/icons/mushroomCapsBack.svg
// module id = 708
// module chunks = 0